import TextArea from "features/common/BaseComponents/Textarea/TextArea";
import formFieldHOC from "../../InputfieldHOC/InputfieldHOC";

export default formFieldHOC(TextArea);
